<template lang="">
  <div class="download-tip">
    <img src="@assets/icons/nav/logo.webp" class="logo" />
    <div class="qr-code">
      <qrcode-vue :value="qrCodeUrl" :size="180" level="H" />
    </div>
    <div class="button">
      <button @click="goToDownload">扫描下载懂球体育AI APP</button>
    </div>
    <p class="text">{{ addrs }}</p>
  </div>
</template>
<script setup>
import { ref, watchEffect, getCurrentInstance, computed } from 'vue'
import { useRouter } from 'vue-router'
import QrcodeVue from 'qrcode.vue'
import { useConfigStore } from '@/stores/config'

const router = useRouter()
const { proxy } = getCurrentInstance()
const configStore = useConfigStore()

// 从store获取下载地址,如果为空则使用默认值
const qrCodeUrl = computed(() => {
  const channelId = localStorage.getItem('channelId') || 'default'
  const linkId = localStorage.getItem('linkId') || ''
  const baseUrl = configStore.downloadUrl || 'https://download.dbf666.com/'
  return `${baseUrl}?channel=${channelId}${linkId ? `&linkId=${linkId}` : ''}`
})

const addrs = ref('')
watchEffect(() => {
  addrs.value = proxy.$config[__TEMPLATE__].addrs
})

const goToDownload = () => {
  const channelId = localStorage.getItem('channelId') || 'default'
  const linkId = localStorage.getItem('linkId') || ''
  const query = {
    channel: channelId
  }
  if (linkId) {
    query.linkId = linkId
  }
  router.push({
    path: '/download',
    query
  })
}
</script>
<style lang="scss" scoped>
.download-tip {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .logo {
    width: 100px;
  }
  .qr-code {
    width: 200px;
    height: 200px;
    background: url('@assets/icons/nav/qr-code-bg.webp') no-repeat center center;
    background-size: 100% 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 180px;
      height: 180px;
    }
  }
  .button {
    width: 210px;
    height: 46px;
    background: $components-download-tip-primary;
    border-radius: 39px 39px 39px 39px;
    margin-top: 20px;
    button {
      width: 100%;
      height: 100%;
      background: transparent;
      border: none;
      color: $components-download-tip-white;
    }
  }
  .text {
    font-size: 16px;
    margin-top: 10px;
    color: $components-download-tip-primary;
  }
}
</style>
